module.exports = __webpack_public_path__ + "img/hb.a482811a.jpg";